function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { performerRetrieve, prescriptorRetrieve } from "../dmp-utils";
import { arrayIfNeeded } from "../xml-parsed-helpers";
import AbstractDmpParser from "./abstract-dmp-parser";
export default class VaccinesDmpParser extends AbstractDmpParser {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "journalEventClassName", "VaccinesRefundedJournalEvent");
  }
  canParse(section) {
    const code = section.code?._attributes?.code;
    const title = section.title?._text;
    return code == "11369-6" && (title == "Vaccinations" || title == "Vaccins");
  }
  parse(section) {
    return this.getEntries(section).map(entry => {
      let vaccineObject;
      const vaccine = entry.substanceAdministration;
      if (vaccine) {
        vaccineObject = this.parseVaccine(vaccine);
      }
      if (vaccineObject) {
        return vaccineObject;
      }
    }).filter(Boolean);
  }
  parseVaccine(vaccine) {
    const manufacturedMaterial = vaccine.consumable?.manufacturedProduct?.manufacturedMaterial;
    if (manufacturedMaterial.code?._attributes?.nullFlavor || manufacturedMaterial.code?._attributes?.codeSystem == "1.2.250.1.213.2.63") return;
    let sourceConcept;
    let sourceValue;
    let sourceLabel;
    let quantity;
    const cisSource = manufacturedMaterial.code?._attributes;
    const translations = arrayIfNeeded(manufacturedMaterial.code?.translation);
    const cipSource = translations.find(translation => translation._attributes?.codeSystem == "1.2.250.1.215.200.1.1.1");
    const ucdSource = translations.find(translation => translation._attributes?.codeSystem == "1.2.250.1.215.200.1.1.2");
    if (cipSource) {
      sourceConcept = "CIP";
      sourceValue = cipSource._attributes?.code;
      sourceLabel = cipSource._attributes?.displayName;
    } else if (cisSource) {
      sourceConcept = cisSource.codeSystem;
      sourceValue = cisSource.code;
      sourceLabel = cisSource.displayName;
    } else if (ucdSource) {
      sourceConcept = "UCD";
      sourceValue = ucdSource._attributes?.code;
      sourceLabel = ucdSource._attributes?.displayName;
    }
    if (!sourceConcept || !sourceValue || !sourceLabel) return;
    let prescriptionEntryRelationship;
    if (Array.isArray(vaccine.entryRelationship)) {
      prescriptionEntryRelationship = vaccine.entryRelationship?.find(relationship => relationship._attributes?.typeCode == "REFR");
    } else {
      if (vaccine.entryRelationship?._attributes?.typeCode == "REFR") {
        prescriptionEntryRelationship = vaccine.entryRelationship;
      }
    }
    let occurredAt;
    if (prescriptionEntryRelationship) {
      quantity = parseInt(prescriptionEntryRelationship.supply?.quantity?._attributes?.value);
      occurredAt = this.parseOccurredAt(prescriptionEntryRelationship, "supply.performer.time._attributes.value");
    }
    if (!occurredAt) return;
    return {
      occurredAt,
      prestations: [{
        sourceConcept,
        sourceValue,
        sourceLabel,
        quantity
      }],
      prescriptor: prescriptorRetrieve(vaccine.entryRelationship?.supply?.author),
      performer: performerRetrieve(vaccine.entryRelationship?.supply?.performer)
    };
  }
}